import PersonalData from '../../entities/PersonalData/ui/PersonalData';
import styles from './PersonalDataPage.module.scss';

const PersonalDataPage = () => {
    return ( 
        <div className={styles.personal}>
            <PersonalData/>
        </div>
     );
}
 
export default PersonalDataPage;